module.exports = __webpack_public_path__ + "static/media/013.6cbc91b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/013.jpg
// module id = 486
// module chunks = 0